import React from 'react';
import ReactECharts from 'echarts-for-react';
import { Spin, Empty, Select } from 'antd';
import { formatForChart } from '../utils/cityWaterDataUtils';

const { Option } = Select;

const CityDataChart = ({ data, indicators = [], loading, city }) => {
  const [chartType, setChartType] = React.useState('line');

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!data || !data.data || data.data.length === 0) {
    return <Empty description="暂无数据" />;
  }

  if (indicators.length === 0) {
    return <Empty description="请选择要展示的指标" />;
  }

  const { x, series } = formatForChart(data, indicators);

  // 生成颜色
  const colors = [
    '#1890ff', '#52c41a', '#faad14', '#f5222d', '#722ed1', 
    '#13c2c2', '#eb2f96', '#fa541c', '#a0d911', '#2f54eb'
  ];

  const option = {
    title: {
      text: `${city} - 多指标数据分析`,
      left: 'center',
      textStyle: {
        fontSize: 16,
        fontWeight: 'normal'
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      },
      formatter: function(params) {
        let tooltip = `年份: ${params[0].axisValue}<br/>`;
        params.forEach(param => {
          if (param.value !== null) {
            tooltip += `${param.seriesName}: ${param.value}<br/>`;
          }
        });
        return tooltip;
      }
    },
    legend: {
      data: indicators,
      top: 40,
      type: 'scroll',
      width: '80%',
      left: 'center'
    },
    grid: {
      left: '8%',
      right: '8%',
      bottom: '15%',
      top: indicators.length > 4 ? '120px' : '100px',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {
          title: '保存图片'
        },
        dataZoom: {
          title: {
            zoom: '区域缩放',
            back: '区域缩放还原'
          }
        },
        restore: {
          title: '还原'
        },
        magicType: {
          type: ['line', 'bar'],
          title: {
            line: '折线图',
            bar: '柱状图'
          }
        }
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: chartType === 'bar',
      data: x,
      axisLabel: {
        rotate: 45,
        interval: Math.ceil(x.length / 15)
      }
    },
    yAxis: {
      type: 'value',
      name: '数值',
      nameTextStyle: {
        fontSize: 12
      }
    },
    dataZoom: [
      {
        type: 'inside',
        start: 0,
        end: 100
      },
      {
        start: 0,
        end: 100,
        height: 30,
        bottom: 30
      }
    ],
    series: series.map((serie, index) => ({
      name: serie.name,
      type: chartType,
      data: serie.data,
      smooth: chartType === 'line',
      symbol: 'circle',
      symbolSize: chartType === 'line' ? 4 : 0,
      lineStyle: chartType === 'line' ? {
        width: 2,
        color: colors[index % colors.length]
      } : undefined,
      itemStyle: {
        color: colors[index % colors.length]
      },
      areaStyle: chartType === 'line' && indicators.length === 1 ? {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: `${colors[index % colors.length]}30`
          }, {
            offset: 1, color: `${colors[index % colors.length]}10`
          }]
        }
      } : undefined
    }))
  };

  return (
    <div>
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ color: '#666', fontSize: '14px' }}>
          共 {x.length} 个数据点，{indicators.length} 个指标
        </div>
        <Select
          value={chartType}
          onChange={setChartType}
          style={{ width: 120 }}
          size="small"
        >
          <Option value="line">折线图</Option>
          <Option value="bar">柱状图</Option>
        </Select>
      </div>
      
      <ReactECharts 
        option={option} 
        style={{ height: '450px', width: '100%' }}
        opts={{ renderer: 'canvas' }}
      />
    </div>
  );
};

export default CityDataChart;